module.exports = __webpack_public_path__ + "img/MiddleSide_right.a2f2ae64.jpg";